<template>
  <div class="yonghuyemian">
    <Nav ref="navRef"></Nav>
    <div style="height: 80px"></div>
    <div class="yonghuyemian-bottom">
      <div class="yonghuyemian-bottom-top" v-if="data.userInfo">
        <div class="yonghuyemian-bottom-top-bottom">
          <div class="userinfo_img">
            <img :src="data.userInfo.avatar" alt="" />
          </div>
          <div class="userInfo_title">
            <div class="userinfo_box">
              <div class="name useall">{{ data.userInfo.nickname }}</div>
              <div class="userinfo_grede">
                <img :src="
                    'https://oss.ansongqiubo.com/Image/grade/' + data.userInfo.level + '.png'
                  " alt="" />
              </div>
              <!-- <div style="color: #635811;text-align: center;line-height: 24px;margin-top:5px;margin-left:10px;width: 53px;height: 24px;background: #FFF9D9;border-radius: 2px;border: 1px solid #2D8FFF;">富人</div> -->
            </div>
            <div ref="zhankai" class="userinfo_desc">
              个人简介：
              <span v-if=" data.userInfo.identity==2 && data.roomInfo.isLive ==1" class="useall">{{
                data.userInfo.desc
                  ? data.userInfo.desc
                  : "这个人很懒什么都没有留下"
              }}</span>
              <span v-else>简介:暂未开播</span>
            </div>
            <!-- <div v-if="Zhankai" @click="zhankai" style="cursor: pointer;cursor:pointer;color: #D5D5D5;margin-top:5px;height: 35px;">
                        展开
                        <img src="https://oss.ansongqiubo.com/Image/userimage/shouqi.png" alt="">
                    </div>
                    <div v-else @click="shouqi" style="cursor: pointer;color: #D5D5D5;margin-top:5px;height: 35px;">
                        收起
                        <img src="https://oss.ansongqiubo.com/Image/userimage/zhankai.png" alt="">
                    </div> -->
          </div>
          <div class="showCare_btn">
            <div class="showCare_box">
              <div class="jubao" @click="Jubao">举报</div>
              <div v-if="data.relation.folowStatus == 0" @click="Guanzhu2(data.userInfo.uid)" class="redia_guanzhu">
                + 关注
              </div>
              <div v-if="data.relation.folowStatus == 1" @click="quxiaoguanzhu(data.userInfo.uid)" class="double_care">
                <img src="https://oss.ansongqiubo.com/assets/person/icon_dui@2x.png" alt="" srcset="" />已关注
              </div>
              <div v-if="data.relation.folowStatus == 2" class="double_care">
                <img src="https://oss.ansongqiubo.com/assets/person/icon_huxiang@2x.png" alt="" srcset="" />互相关注
              </div>
            </div>
          </div>
          <!-- <div style="width: 20%; display: flex; align-items: center">
            <div

              style="
                color: #ffffff;
                height: 40px;
                border-radius: 4px;
                background-color: #721edc;
                width: 91px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
              "
            >
              关注+
            </div>
            <div
              v-if="data.relation.folowStatus == 1"
              @click="quxiaoguanzhu(data.userInfo.uid)"
              style="
                color: #666666;
                height: 40px;
                border-radius: 4px;
                background-color: rgba(218, 218, 218, 1);
                width: 91px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
              "
            >
              已关注
            </div>
            <div
              v-if="data.relation.folowStatus == 2"
              style="
                color: #ffffff;
                height: 40px;
                border-radius: 4px;
                background-color: #721edc;
                width: 91px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
              "
            >
              互相关注
            </div>
          </div> -->
        </div>
      </div>
      <div class="yonghuyemian-bottom-center">
        <div style="display: flex; width: 80%">
          <div @click="Zuopin">
            <div :class="henggang == 1 ? 'activenav' : ''" class="nav_item" style="">
              关注&nbsp;{{data.relation && data.relation.follows?data.relation.follows:''}}
            </div>
          </div>
          <div style="margin-left: 70px" @click="Shoucang">
            <div class="nav_item" :class="henggang == 2 ? 'activenav' : ''">
              粉丝&nbsp;{{data.relation && data.relation.fans?data.relation.fans:''}}
            </div>
          </div>
        </div>
      </div>
      <div class="yonghuyemian-bottom-bottom">
        <div class="yonghuyemian-bottom-bottom-left">
          <div class="_fensi_list">
            <div v-show="shoucang" class="_fensi_item" v-for="(item, index) in guanzhudata.list" :key="index">
              <div class="header_class">
                <img :src="item.avatar" alt="" />
              </div>
              <div class="nickname ">
                <div class="name useall">
                  {{ item.nickname }}
                </div>
                <div class="desc useall" >
                 简介： {{ item.desc ? item.desc : "用户很懒什么都没留下" }}
                </div>




              </div>
              <!-- <div
                v-if="item.status === 2"
                style="
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>互相关注</span>
              </div>
              <div
                v-if="item.status === 1"
                @click="quxiaoguanzhu(item.uid)"
                style="
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>已关注</span>
              </div>
              <div
                v-if="item.status === 0"
                @click="Guanzhu(item.uid)"
                style="
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>关注+</span>
              </div> -->
              <!-- <div
                v-show="faxiaoxi"
                style="
                  cursor: pointer;
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 50px;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>发消息</span>
              </div> -->
            </div>
            <div v-show="zuopin" class="_fensi_item" v-for="(item, index) in fensidata.list" :key="'info2-' + index">
              <div class="header_class">
                <img style="
                    margin-top: 2px;
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                  " :src="item.avatar" alt="" />
              </div>
              <div class="nickname ">
                <div class="name useall">
                  {{ item.nickname }}
                </div>
                <div class="desc useall" >
                 简介： {{ item.desc ? item.desc : "用户很懒什么都没留下" }}
                </div>

              </div>

            </div>

            <div v-show="noa" style="
                margin-top: 90px;
                color: #d5d5d5;
                width: 100%;
                height: 100%;
                text-align: center;
              ">
              <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
              <div style="font-size: 18px; margin-top: 20px">
                该用户还没有关注的人
              </div>
            </div>
            <div v-show="noaa" style="
                margin-top: 90px;
                color: #d5d5d5;
                width: 100%;
                height: 100%;
                text-align: center;
              ">
              <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
              <div style="font-size: 18px; margin-top: 20px">
                该用户暂时还没有粉丝～
              </div>
            </div>
          </div>
         <!-- <div class="pagenumber" v-if="fensidata.list && fensidata.list.length>0">
            <el-pagination
              background
              @current-change='currentChange'
              layout="prev, pager, next"
              :page-size="51"
              :total="totalPage?totalPage:0">
            </el-pagination>
          </div> -->
        </div>

        <div class="yonghuyemian-bottom-bottom-right">
          <div style="
              box-sizing: border-box;
              padding: 20px;
              height: 200px;
              background-color: #fff;
            " v-if="data.userInfo">
            <div style="font-size: 18px">个人资料</div>
            <div style="margin-top: 20px; color: #a6a6a6; font-size: 14px">
              龙珠号&nbsp;&nbsp; <span class="useall">{{ data.userInfo.account }}</span>
            </div>
            <div style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              性别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="data.userInfo.gender == 1">男</span>
              <span v-if="data.userInfo.gender == 2">女</span>
              <span v-if="data.userInfo.gender == 0">保密</span>
            </div>
            <div v-if="data.userInfo.birthday" style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              生日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
                data.userInfo.birthday
              }}</span>
            </div>
            <div v-else style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              生日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>暂无</span>
            </div>
            <div v-if="data.userInfo.birthday" style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              地区&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
                data.userInfo.region
              }}</span>
            </div>
            <div v-else style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              地区&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>暂无</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Report v-show="jubao" :jubao="jubao" @jubao="jubaos" :userUid="userUid"></Report>
  </div>
</template>

<script>
  // import axios from 'axios'
  import Nav from "../component/Nav.vue";
  import Report from "../component/Report.vue";

  import qs from "qs";
  export default {
    data() {
      return {
        zuopin: false,
        shoucang: true,
        data: [],
        fensidata: [],
        guanzhudata: [],
        faxiaoxi: false,
        Zhankai: true,
        totalPage: 0,
        jubao: false,
        userUid: 0, //要禁言的用户UID
        noa: false,
        noaa: false,
        henggang: 1,
      };
    },
    mounted() {
      // 获取用户信息
      this.User();
      // 获取粉丝关注
      this.huoqufensiguanzhu();
      this.userUid = this.$route.query.uid;
    },
    methods: {
      currentChange() {

      },
      // 举报---------------------
      Jubao() {
        console.log(this.userUid);
        this.jubao = true;
      },
      jubaos(e) {
        this.jubao = e;
      },
      User() {
        var uid = this.$route.query.uid;
        this.$axios
          .get(this.api + "/v1/profile/user", {
            params: {
              uid: uid,
            },
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            this.data = res.data.data;
            this.totalPage = Number(this.data.relation.fans)
          });
      },
      huoqufensiguanzhu() {
        var uid = this.$route.query.uid;
        // 获取关注
        this.$axios
          .get(this.api + "/v1/relation/otfollow", {
            params: {
              uid: uid,
              pageIndex: 0,
            },
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            // console.log(res);
            this.guanzhudata = res.data.data;
            if (this.guanzhudata.list.length <= 0) {
              this.noa = true;
            }
          });
        // 获取粉丝
        this.$axios
          .get(this.api + "/v1/relation/otfans", {
            params: {
              uid: uid,
              pageIndex: 0,
            },
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            // console.log(res);
            this.fensidata = res.data.data;
          });
      },
      // 用户简介展开收起
      zhankai() {
        this.$refs.zhankai.style.height = "80px";
        this.Zhankai = false;
      },
      shouqi() {
        this.$refs.zhankai.style.height = "26px";
        this.Zhankai = true;
      },
      dateFormat: function(time) {
        var times = time * 1000;
        var date = new Date(time);
        var year = date.getFullYear();
        var month =
          date.getMonth() + 1 < 10 ?
          "0" + (date.getMonth() + 1) :
          date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // 拼接
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      },
      Guanzhu(uid) {
        this.token = localStorage.getItem("token");
        if(!this.token){
          this.$refs.navRef.Longin();
          return
        }
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/follow",
          method: "post",
          data: {
            actionUid: uid,
          },
        }).then((res) => {
          this.huoqufensiguanzhu();
        });
      },
      Guanzhu2(uid) {

        this.token = localStorage.getItem("token");
        if(!this.token){
          this.$refs.navRef.Longin();
          return
        }

        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/follow",
          method: "post",
          data: {
            actionUid: uid,
          },
        }).then((res) => {
          this.User();
          this.$message({
            message: "关注成功",
            type: "success",
          });
          this.huoqufensiguanzhu();
        });
      },
      quxiaoguanzhu(uid) {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/unfollow",
          method: "post",
          data: {
            actionUid: uid,
          },
        }).then((res) => {
          this.User();
          this.$message({
            message: "取关成功",
            type: "success",
          });
          this.huoqufensiguanzhu();
        });
      },
      Zuopin() {
        this.henggang = 1;
        if (this.guanzhudata.list.length <= 0) {
          this.noaa = false;
          this.noa = true;
          this.shoucang = false;
          this.zuopin = false;
        } else {
          this.shoucang = true;
          this.noaa = false;
          this.noa = false;
          this.zuopin = false;
        }
      },
      Shoucang() {
        this.henggang = 2;
        if (this.fensidata.list.length <= 0) {
          this.noa = false;
          this.noaa = true;
          this.shoucang = false;
          this.zuopin = false;
        } else {
          this.shoucang = false;
          this.noaa = false;
          this.noa = false;
          this.zuopin = true;
        }
      },
    },
    components: {
      Nav,
      Report,
    },
  };
</script>

<style scoped lang='scss' scoped="scoped">
  .file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 260px;
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .avatar-input {
    opacity: 0;
    width: 260px;
    height: 65px;
    display: block;
    position: absolute;
  }

  .yonghuyemian {
    width: 100vw;
    height: 100vh;

    /* background-color: #292929; */
    .pagenumber {
      display: flex;
      justify-content: flex-end;
      padding: 40px;
    }

    div {
      user-select: none;
    }
  }

  .yonghuyemian-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    /* height: 90%; */
    box-sizing: border-box;
    padding-top: 20px;
    background-color: rgba(247, 248, 250, 1);
    min-width: 1200px;

    .yonghuyemian-bottom-top {
      margin: 0 auto;
      width: 1200px;
      height: 118px;
      background: #ffffff;
      position: relative;
    }

    .yonghuyemian-bottom-top-bottom {
      width: 1200px;
      height: 118px;
      position: relative;
      box-sizing: border-box;
      padding: 0 24px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .userinfo_desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      .show {
        cursor: pointer;
        color: #d5d5d5;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      .hiddens {
        cursor: pointer;
        color: #d5d5d5;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }

      .userinfo_box {
        display: flex;
        align-items: center;
      }

      .showCare_btn {
        flex: 2;
        cursor: pointer;
        display: flex;
        justify-content: flex-end;

        .showCare_box {
          display: flex;
          flex-direction: column;

          .care_btn_ok {
            width: 25%;
            display: flex;
            align-items: center;
          }

          .redia_guanzhu {
            cursor: pointer;
            margin-left: 15px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            justify-content: center;
            border: 1px solid rgba(228, 228, 228, 0.2);
            background: linear-gradient(270deg, #f75325 0%, #ed1010 100%);
            transition: all 0.1s;
            display: flex;
            justify-content: center;
            width: 98px;
            height: 36px;
            line-height: 36px;
            text-align: center;

            img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }

            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #fff;
            }
          }

          .double_care {
            cursor: pointer;
            margin-left: 15px;
            display: flex;
            align-items: center;
            border-radius: 4px;
            justify-content: center;
            border: 1px solid rgba(228, 228, 228, 0.21);
            background: #dadada;
            width: 98px;
            height: 36px;
            text-align: center;
            line-height: 36px;

            img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }

            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
            }
          }

          .double_care:hover {
            background: #fff0f0;

            span {
              color: rgba(237, 16, 16, 1);
            }
          }

          .jubao {
            position: absolute;
            right: 20px;
            top: 10px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }

          .jubao:hover {
            color: #333;
          }

          .care {
            width: 98px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            background: #dadada;
            border-radius: 4px;
          }
        }
      }

      .userinfo_grede {
        width: 36px;
        height: 16px;
        margin-left: 6px;

        img {
          width: 36px;
          height: 16px;
        }
      }

      .userInfo_title {
        .name {
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
      }

      .userinfo_img {
        margin-right: 12px;

        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
        }
      }
    }
  }

  .yonghuyemian-bottom-top-top {
    width: 1200px;
    height: 160px;
    overflow: hidden;
    position: relative;
  }

  .yonghuyemian-bottom-top-top>div {
    width: 84px;
    height: 40px;
    border-radius: 4px;
    background-color: rgba(70, 70, 70, 1);
    text-align: center;
    line-height: 40px;
    position: absolute;
    top: 50px;
    right: 20px;
    color: white;
  }

  .yonghuyemian-bottom-top-center {
    width: 1200px;
    height: 160px;
    background-image: linear-gradient(180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%);
    position: absolute;
    top: 0px;
  }

  .yonghuyemian-bottom-top-bottom {
    width: 1200px;
    /* height: 114px; */
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    display: flex;
  }

  .yonghuyemian-bottom-center {
    width: 1200px;
    height: 60px;
    background-color: #fff;
    padding: 10px 40px;
    margin: 12px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .nav_item {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      cursor: pointer;
    }

    .activenav {
      color: rgba(114, 30, 220, 1) !important;
    }
  }

  .yonghuyemian-bottom-bottom {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }

  .yonghuyemian-bottom-bottom-left {
    width: 73%;
    box-sizing: border-box;
    padding: 10px;
    background-color: #fff;
    overflow: hidden;

    ._fensi_list {
      width: calc(100% + 35px);
      height: 600px;
      overflow-y: scroll;
    }

    ._fensi_item {
      border-bottom: 2px solid rgba(218, 218, 218, 0.1);
      width: 100%;
      height: 80px;
      justify-content: space-between;
      display: flex;
      box-sizing: border-box;
      padding: 10px 30px 10px 10px;
      display: flex;
      align-items: center;
    }

    .nickname {
      flex: 2;
      display: flex;
      flex-direction: column;
      margin-left: 12px;
      align-items: flex-start;

      .name {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }

      .desc {
        margin-top: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }

    .header_class {
      text-align: center;
      border-radius: 50%;
      width: 60px;
      height: 60px;

      img {
        border-radius: 50%;

        width: 60px;
        height: 60px;
      }
    }
  }

  .yonghuyemian-bottom-bottom-right {
    width: 25%;
    margin-left: 2%;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/component/Yonghuyemian.vue